<template>
  <KkAccessibleButton
    class="kk-icon-button"
    :class="{
      'kk-icon-button--transparent': isTransparent,
    }"
    @click="(event) => $emit('click', event)"
  >
    <KkIconWithBadge
      :icon-name="iconName"
      size="sm"
      :is-show-badge="isShowBadge"
    />
  </KkAccessibleButton>
</template>

<script>
import KkIconWithBadge from '../../KkIconWithBadge';
import KkAccessibleButton from '../../KkAccessibleButton';

export default {
  name: 'KkIconButton',
  components: {
    KkIconWithBadge,
    KkAccessibleButton,
  },
  props: {
    iconName: {
      type: String,
      required: true,
    },
    isShowBadge: {
      type: Boolean,
      default: false,
    },
    isTransparent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
};
</script>
